import { LocalFind } from '@weblite/persist'
import axios from 'axios'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import { closeForwardList, openForwardList } from '$logic/router'
import { openRoom } from '$logic/opened-room'
import {
  MESSAGE_CAPTION_SIZE,
  sendNewMessage,
  sendTextMessage,
} from '$logic/message'
import { getRoom, getRoomPermissions } from '$logic/room'
import { showNoPermissoinToSendMessageSnackbar } from '$comp/snackbars'
import { validateMessageFileSizeAndShowError } from '$logic/message/helper'

const SHARED_TARGET_DB_NAME = 'shareTarget'
const SHARED_TARGET_DB_VERSION = 2

async function sendSharedMessage({
  files,
  link,
  text,
  title,
}: {
  files: File[]
  text: string
  link: string
  title: string
}) {
  openForwardList(
    async (roomIds, caption) => {
      const room = await getRoom(roomIds[0])
      if (files && files.length) {
        if (files.length > 1) {
          // eslint-disable-next-line no-restricted-syntax
          for (const file of files)
            if (validateMessageFileSizeAndShowError(file))
              sendNewMessage(file, null, null, roomIds[0], room?.type)
          if (caption) sendTextMessage(caption, null, roomIds[0], room?.type)
        } else if (validateMessageFileSizeAndShowError(files[0])) {
          sendNewMessage(
            files[0],
            text?.slice(0, MESSAGE_CAPTION_SIZE),
            null,
            roomIds[0],
            room?.type,
          )
          if (caption) sendTextMessage(caption, null, roomIds[0], room?.type)
        }
        openRoom(roomIds[0])
      } else if (text || link || title) {
        sendTextMessage(text || link || title, null, roomIds[0], room?.type)
        openRoom(roomIds[0])
      }
    },
    1,

    destRoomId =>
      closeForwardList().then(async () => {
        const { sendMessage } = await getRoomPermissions(destRoomId)
        if (!sendMessage) {
          showNoPermissoinToSendMessageSnackbar()
          return
        }
        const room = await getRoom(destRoomId)
        for (const file of files)
          if (validateMessageFileSizeAndShowError(file))
            sendNewMessage(file, null, null, destRoomId, room?.type)
        openRoom(destRoomId)
      }),

    true,
  )
}

export function handleSharedTarget() {
  const open = indexedDB.open(SHARED_TARGET_DB_NAME, SHARED_TARGET_DB_VERSION)

  open.onsuccess = () => {
    const db = open.result
    const transaction = db.transaction('shareTargetStore', 'readwrite')
    const store = transaction.objectStore('shareTargetStore')
    const shareTargetQuery = store.get(1)
    shareTargetQuery.onsuccess = () => {
      sendSharedMessage(shareTargetQuery.result.dataToShare)
    }
    store.clear()
    transaction.oncomplete = () => {
      db.close()
    }
  }
}

function downloadFile(fileId: string, port: number) {
  const fileUrl = `http://localhost:${port}/file/${encodeURIComponent(fileId)}`

  const authToken = LocalFind('auth')?.token

  return axios
    .get(fileUrl, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      responseType: 'blob',
    })
    .then(response => {
      const fileName =
        response.headers['content-disposition']?.split('filename=')?.[1] ||
        'image.jpg'

      return new File([response.data], fileName, {
        type: response.headers['content-type'],
        lastModified: dateWithOffset(),
      })
    })
    .catch(err => console.error(err))
}

export async function handleNewShareTarget({
  port,
  text,
  files: fileIds,
  link,
  title,
}: {
  port: number
  files: string[]
  title: string
  text: string
  link: string
}) {
  const files = fileIds?.length
    ? await Promise.all(fileIds.map(fileId => downloadFile(fileId, port)))
    : undefined

  sendSharedMessage({ files: files || [], link, text, title })
}
